import {Injectable} from '@angular/core';
import {Filtro} from '~model/filtro/filtros/filtro';
import {ComponentStore} from '@ngrx/component-store';
import {Store} from '@ngrx/store';
import {Map} from 'immutable';
import {Observable} from 'rxjs';
import {filtroSetInput} from '~feature/feature-filtro/feature-filtro.actions';
import {RotaVo} from '~model/vo/rota-vo';

export interface ToolbarFiltroState {
  filtros: Map<string, Filtro<RotaVo>>;
}

@Injectable()
export class ToolbarFiltroStore extends ComponentStore<ToolbarFiltroState> {

  constructor(
    private readonly store: Store
  ) {
    super({
      filtros: Map<string, Filtro<RotaVo>>(),
    });
  }

  saveFiltro(filtro: Filtro<RotaVo>): void {
    console.log('Salvando filtro', filtro.getFiltroNome(), filtro);

    //* 1. Remove o filtro existente com o mesmo nome (se houver)
    this.setState((state) => ({
      ...state,
      filtros: this.getState()
        .filtros
        .remove(filtro.getFiltroNome()),
    }));

    //* 2. Adiciona o novo filtro
    this.setState((state) => ({
      ...state,
      filtros: this.getState()
        .filtros
        .set(filtro.getFiltroNome(), filtro),
    }));

    //* 3. Dispara a action que VAI executar o filtro
    this.store.dispatch(filtroSetInput({
      filtros: this.getState().filtros.toSet().toArray() || [],
    }) as any);
  }

  applyFiltros(filtros: Map<string, Filtro<RotaVo>>): void {
    this.setState({filtros});

    this.store.dispatch(filtroSetInput({
      filtros: filtros.toSet().toArray() || [],
    }) as any);
  }

  updateFiltros(filtros: Map<string, Filtro<RotaVo>>): void {
    this.setState((state) => ({
      ...state,
      filtros,
    }));
  }

  getFiltro(nome: string): Filtro<RotaVo> | undefined {
    return this.getState().filtros.get(nome);
  }

  getState(): ToolbarFiltroState {
    return this.get();
  }

  on(): Observable<ToolbarFiltroState> {
    return this.state$;
  }

  clearAllFilters(): void {
    this.setState({
      filtros: Map<string, Filtro<RotaVo>>(),
    });

    this.store.dispatch(filtroSetInput({
      filtros: [],
    }) as any);
  }
}
